import { Lead } from "shared/topchef.types";
import PublicLeadContent from "../public-lead-content/PublicLeadContent"
import { useTranslation } from "react-i18next";

type LeadContentProps = {
  lead: Lead;
};

const LeadContent = ({lead }: LeadContentProps) => {
    const { t } = useTranslation();
    
  return (
      <>
        <PublicLeadContent publicLead={lead} />

        <div id="brief_details_contact" className="p-3 bg-light mb-4 rounded">
                <h5 className="mb-2">{t('lead.clientInfo')}</h5>
                <div className="row g-2">
                    <div className="col-md-6">
                        <strong>{t('lead.email')}</strong>
                        <a id="brief_contact_email" href={'mailto:'+lead.contactEmailAddress}>{lead.contactEmailAddress}</a>
                    </div>
                    <div className="col-md-6">
                        <strong>{t('lead.mobilePhone')}</strong>
                        <a id="brief_contact_tel" href={'tel:'+ lead.contactMobilePhone}>{lead.contactMobilePhone}</a>
                    </div>
                    <div className="col-md-6">
                        <strong>{t('lead.company')}</strong>
                        <span id="brief_company">{lead.contactCompany}</span>
                    </div>
                    <div className="col-md-6">
                        <strong>{t('lead.fullName')}</strong>
                        <span id="brief_contact_name">{lead.contactName}</span>
                    </div>
                    <div className="col-md-6">
                        <strong>{t('lead.landlinePhone')}</strong>
                        <a id="brief_contact_tel_fix" href={'tel:'+ lead.contactLandlinePhone}>{lead.contactLandlinePhone}</a>
                    </div>
                </div>
            </div>
      </>
  );

}

export default LeadContent;
